import { render, staticRenderFns } from "./scc-user-profile.vue?vue&type=template&id=4fa0acd6&"
import script from "./scc-user-profile.vue?vue&type=script&lang=js&"
export * from "./scc-user-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports